import { useEffect, useState } from 'react'
import { useMediaQuery } from '@/hooks/useMediaQuery'

/** Presentation-only streaming. Answers remain explicit form values. */
export function useStreamedText(text: string, enabled = true, mode: 'characters' | 'words' = 'characters') {
  const reducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)')
  const [frame, setFrame] = useState({ text, count: 0 })
  const count = frame.text === text ? frame.count : 0
  useEffect(() => {
    if (!enabled || reducedMotion) return
    let next = 0
    const timer = window.setInterval(() => {
      next = mode === 'words' ? Math.min(text.length, next + (text.slice(next).match(/^\s*\S+\s*/)?.[0].length ?? 1)) : Math.min(text.length, next + 2)
      setFrame({ text, count: next })
      if (next === text.length) window.clearInterval(timer)
    }, mode === 'words' ? 85 : 22)
    return () => window.clearInterval(timer)
  }, [text, reducedMotion, enabled, mode])
  return { visible: !enabled ? '' : reducedMotion ? text : text.slice(0, count), done: enabled && (reducedMotion || count >= text.length) }
}
